/**
 * Figma-exact number copy for the Needs Approval surfaces (GRAVY-10366).
 *
 * Both helpers exist because `toFixed()` pads: it renders `0.0 mi away` and
 * `6.00` where frames 39583-197886 / 39621-199038 show `0 mi away` and `6`.
 * The design keeps a decimal only when there is one to show.
 */

/** `0` → "0", `0.1` → "0.1", `6.24` → "6.2". One decimal, no padding. */
export const oneDecimal = (n: number): string => String(Math.round(n * 10) / 10);

/** `6` → "6", `7.5` → "7.5", `7.53` → "7.53". Up to two decimals, no padding. */
export const upToTwoDecimals = (n: number): string => String(Math.round(n * 100) / 100);
